export type PrizmOrientation = 'vertical' | 'horizontal';
